const API=(import.meta.env.VITE_API_BASE as string|undefined)??"/dating-v1/api/v1";

export const ADMIN_AUTH_REQUIRED_EVENT = "dating:admin-auth-required";

export class ApiError extends Error{status:number;code:string;constructor(status:number,code:string,message:string){super(message);this.status=status;this.code=code;}}
export async function api<T>(path:string,options:RequestInit={}):Promise<T>{
  const response=await fetch(`${API}${path}`,{credentials:"include",headers:{...(!options.body||options.body instanceof FormData?{}:{"Content-Type":"application/json"}),...options.headers},...options});
  const payload=await response.json().catch(()=>({}));
  if(!response.ok) {
    const error=new ApiError(response.status,payload.error??"REQUEST_FAILED",payload.message??"Request failed");
    if(error.status===401&&error.code==="ADMIN_AUTH_REQUIRED"&&typeof window!=="undefined")
      window.dispatchEvent(new Event(ADMIN_AUTH_REQUIRED_EVENT));
    throw error;
  }
  return payload as T;
}
export function json(method:string,body:unknown):RequestInit{return {method,body:JSON.stringify(body)};}
